import { Group } from '@mantine/core';

import CarrierLogo from '../../../../../components/columns/carrier-logo-column/carrier-logo';
import styles from './styles.module.less';

type CarrierServiceColumnProps = {
  carrierId?: string | number;
  trackingService?: string;
};

export const CarrierServiceColumn = ({ carrierId, trackingService }: CarrierServiceColumnProps) => {
  const serviceName = trackingService || '';

  return (
    <Group gap={8}>
      {carrierId && <CarrierLogo carrierId={Number(carrierId)} className={styles['carrier-logo']} logoType='icon' providerId={undefined} />}
      <span>{serviceName}</span>
    </Group>
  );
};
